import { useState } from "react"
import { Dropdown } from "semantic-ui-react"
import { SelectField } from "../../../../../../components/financialTables/configuration/fields";
import KeyValue from "../../../../../../structures/keyValePair";

class PasteModeModel {
    static EU_MODE = "EU"
    static US_MODE = "US"

    static _mode = PasteModeModel.US_MODE

    /**
     * @param {string} mode Required
     */
    static set(mode) {
        PasteModeModel._mode = mode
    }

    /**
     * @returns {string} not-null
     */
    static get() {
        return PasteModeModel._mode
    }
}

function PasteMode() {
    let [mode, setMode] = useState(PasteModeModel.get());

    return <div className='pasteOps flex flex-align-center gap-5'><span>Paste Number Mode: </span>
        <SelectField
        opsKV={[new KeyValue(PasteModeModel.US_MODE, "US"), new KeyValue(PasteModeModel.EU_MODE, "DE")]}
            onChange={(value) => {
                PasteModeModel.set(value)
                setMode(value)
            }}
            val={mode}
            /></div>
}
export { PasteModeModel, PasteMode }